import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { environment } from 'src/environments/environment';

interface DashboardRole {
  key: string;
  userTypes?: string[];
  flagCheck?: string;
  path: string;
  label: string;
}

@Component({
  selector: 'app-dashboard-switcher',
  templateUrl: './dashboard-switcher.component.html',
  styleUrls: ['./dashboard-switcher.component.scss'],
})
export class DashboardSwitcherComponent {
  constructor(
    public router: Router,
    private apiService: ApiservicesService,
    public activateRoute: ActivatedRoute,
    private cookieService: CookieService,
    public matSnackBar: MatSnackBar
  ) {}

  public cookieData: any = {};
  public env_name = environment.environment_name;

  ngOnInit() {
    if (this.cookieService.getAll()['login_user_details']) {
      this.cookieData = JSON.parse(
        this.cookieService.getAll()['login_user_details']
      );
    }
  }

  readonly dashboardRoles: DashboardRole[] = [
    {
      key: 'is_admin',
      userTypes: ['is_admin'],
      path: '/admin-dashboard',
      label: 'Admin Dashboard',
    },
    {
      key: 'is_astrologer',
      userTypes: ['is_astrologer', 'is_tarotreader'],
      path: '/astrologer-dashboard',
      label: 'Astrologer Dashboard',
    },
    {
      key: 'is_customer',
      userTypes: ['is_social_advo', 'is_customer'],
      path: '/customer-dashboard',
      label: 'Customer Dashboard',
    },
    {
      key: 'is_perennial_mandalism',
      userTypes: ['is_Perennial_Mandalism'],
      flagCheck: 'is_perennial_mandalism',
      path: '/perennial-mandalism-dashboard',
      label: 'Perennial Mandalism Dashboard',
    },
    {
      key: 'is_affiliate',
      userTypes: ['is_affiliate'],
      path: '/affiate-dashboard',
      label: 'Affiliate Dashboard',
    },
    {
      key: 'is_mystery_school',
      flagCheck: 'is_mystery_school',
      path: '/mystery-school-dashboard',
      label: 'Mystery School Dashboard',
    },
    {
      key: 'is_diviner',
      flagCheck: 'is_diviner',
      path: '/divination-certification-dashboard',
      label: 'Diviner Dashboard',
    },
  ];

  // get availableDashboards(): { path: string; label: string }[] {
  //   const user = this.cookieData?.userinfo || {};
  //   return this.dashboardRoles.filter((role) => {
  //     const hasUserType = role.userTypes?.includes(user.user_type);
  //     const hasFlag = role.flagCheck && user[role.flagCheck] === 1;
  //     return hasUserType || hasFlag;
  //   });
  // }

  get availableDashboards(): DashboardRole[] {
  const user = this.cookieData?.userinfo || {};
  return this.dashboardRoles.filter((role) => {
    const hasUserType = role.userTypes?.includes(user.user_type);
    const hasFlag = role.flagCheck && user[role.flagCheck] === 1;
    return hasUserType || hasFlag;
  });
}

  switchToOtherDashboard(dashboard: {
    path: string;
    label: string;
    key?: string;
  }): void {
    // Special case checks
    if (this.env_name === 'main') {
      if (dashboard.key === 'is_diviner') {
        this.matSnackBar.open(
          'This feature will be accessible to Diviner accounts starting February 1, 2026.',
          'Ok',
          { duration: 5000 }
        );
        return; // Prevent navigation
      }

      if (dashboard.key === 'is_perennial_mandalism') {
        this.matSnackBar.open(
          'You will be notified when access to this dashboard becomes available.',
          'Ok',
          { duration: 5000 }
        );
        return; // Prevent navigation
      }
    }

    // Default navigation
    this.router.navigateByUrl(dashboard.path);
  }

  isCurrentDashboard(path: string): boolean {
    return this.router.url.startsWith(path);
  }

  currentPath(): string | null {
    return this.router.url;
  }
}
